import React, { useEffect } from "react";
// import NytLogo from "/public/assets/static/nyt_logo.png";
// import PlosLogo from "/public/assets/static/plos_mh.png";
import './featured.css';

const Featured: React.FC = () => {
	return (
		<div className="featured-wrapper">
			<div className="parallax-overlay"></div>
			<span className="featured-span">Recently Featured In</span>
			<div className="featured-logos">
				<img id="nyt" src="/assets/static/nyt_logo.png" alt="New York Times" />
				<img src="/assets/static/plos_mh.png" alt="Plos Mental Health" />
				<img src="/assets/static/NIH.png" alt="National Institutes of Health" />
				<img src="/assets/static/PsyAr.png" alt="PsyArXiv Prepublication" />
				<img src="/assets/static/mdpi.png" alt="MDPI Open Access Journals" />
				<img src="/assets/static/sage_journals.png" alt="Sage Open Science Journals" />
			</div>
		</div>
	)
}

export default Featured;
